module.exports = __webpack_public_path__ + "img/ogp_idea_big.690685fb.jpg";